/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ComputeAccessCreate = {
  sshPublicKey?: string | undefined;
};

/** @internal */
export const ComputeAccessCreate$inboundSchema: z.ZodType<
  ComputeAccessCreate,
  z.ZodTypeDef,
  unknown
> = z.object({
  ssh_public_key: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "ssh_public_key": "sshPublicKey",
  });
});
/** @internal */
export type ComputeAccessCreate$Outbound = {
  ssh_public_key?: string | undefined;
};

/** @internal */
export const ComputeAccessCreate$outboundSchema: z.ZodType<
  ComputeAccessCreate$Outbound,
  z.ZodTypeDef,
  ComputeAccessCreate
> = z.object({
  sshPublicKey: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    sshPublicKey: "ssh_public_key",
  });
});

export function computeAccessCreateToJSON(
  computeAccessCreate: ComputeAccessCreate,
): string {
  return JSON.stringify(
    ComputeAccessCreate$outboundSchema.parse(computeAccessCreate),
  );
}
export function computeAccessCreateFromJSON(
  jsonString: string,
): SafeParseResult<ComputeAccessCreate, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ComputeAccessCreate$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ComputeAccessCreate' from JSON`,
  );
}
